const QuickCompareLandingConfig = {
  collection: "quick_compare_landing",
  single: true,
  fields: [
    "id",

    "locale.language",
    "locale.enabled_price_types.price_types_id",
    "locale.enabled_attributes.attributes_id"
  ],
  adapter: class QuickCompareLanding {
    constructor(quickCompareLanding) {
      this.id = quickCompareLanding.id;

      // Arbitrary ID name
      this.html_id = `quick-compare-landing`;

      let locale = quickCompareLanding.locale
        ? quickCompareLanding.locale[0]
        : null;
      if (!locale) return;

      this.language = locale.language;
      this.enabled_price_types = (locale.enabled_price_types || []).map(
        ({ price_types_id }) => price_types_id
      );
      this.enabled_attributes = (locale.enabled_attributes || []).map(
        ({ attributes_id }) => attributes_id
      );
    }

    map(collections, maps) {
      this.enabled_price_types = this.enabled_price_types
        .map((id) => maps.price_types[id])
        .filter((v) => !!v);
      this.enabled_attributes = this.enabled_attributes
        .map((id) => maps.attributes[id])
        .filter((v) => !!v);
    }
  }
};

export default QuickCompareLandingConfig;
